// The labels are intentionally not localized so they are easier to find.
export const LOCALES = [
  {id: 'de', label: '🇩🇪 Deutsch', baseUrl: ''},
  {id: 'en', label: '🇺🇸 English', baseUrl: '/en'},
];
